export enum VirtualClassType {
    Perculus = 0,
    BigBlueButton = 1,
    Connect = 2,
    WizIq = 3,
    Ibm = 4,
    Microsoft = 5,
    PerculusPlus = 6,
    Zoom = 7,
    All = 8
}